import React from 'react';
import classNames from 'classnames';
import { useRecoilValue } from 'recoil';
import { shopifyState, toViewPriceFnState } from '../../recoil/atoms';
import { ShopifyCart } from '../../models/ShopifyCart.model';
import { OrderSummaryDiscounts } from './OrderSummaryDiscounts';
import { cartHasGarments } from '../CartHelper';
import { freeShippingThresholdInDollars, getTotalForShippingDiscountFromCart } from '../../discounts';
import styles from './OrderSummary.module.scss';

interface Props {
  cart?: ShopifyCart;
  additionalClass?: string;
}

export const OrderSummary: React.FC<Props> = ({ cart, additionalClass }) => {
  const shopify = useRecoilValue(shopifyState);
  const toViewPriceFn = useRecoilValue(toViewPriceFnState);
  const isUSD = shopify?.currency.active === 'USD';
  const totalForDiscounts = cart ? getTotalForShippingDiscountFromCart(cart) : 0;

  return (
    <div className={classNames(styles.hlCartSubTotalPanel, { [additionalClass ?? '']: additionalClass })} id="hl-cart-subtotal-panel-desktop">
      <div className={styles.hlCartLines}>
        <OrderSummaryDiscounts cart={cart} />

        {isUSD && cartHasGarments(cart) && totalForDiscounts > freeShippingThresholdInDollars && (
          <div className={styles.hlCartLine}>
            <span>Shipping</span>
            <span className={styles.dollarTotal}>
              <span style={{ textTransform: 'uppercase', color: '#737373', fontWeight: '300', fontSize: '13px', paddingRight: '6px' }}>Domestic</span>
              {toViewPriceFn(0)}
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default OrderSummary;
